<script lang="ts">
  import { onMount } from 'svelte';
  import Auth from './Auth';
  import App from "../../App.svelte";
  import {authToken, userInfo} from "../../store.svelte";

  let isAuthenticated = false;
  let loading = true;

  onMount(async () => {
    const params = new URLSearchParams(window.location.search);
    const jwtFromURL = params.get('token');
    if (jwtFromURL) {
      Auth.setToken(jwtFromURL);
      window.history.replaceState({}, document.title, '/');
    }

    if (await Auth.validateToken()) {
      isAuthenticated = true;
      userInfo.set(Auth.getUserInfo()!)
      authToken.set(Auth.getToken())
    } else {
      Auth.clearToken();
    }

    loading = false;
  });

</script>

{#if loading}
  <div class="text-center mt-5">Loading...</div>
{:else}
  {#if isAuthenticated}
    <App />
  {:else}
    <div class="d-flex justify-content-center align-items-center vh-100">
      <div class="text-center">
        <h3 class="mb-3">Login to BinanceHelper</h3>
        <button class="btn btn-danger" onclick={Auth.loginWithGoogle}>
          <i class="bi bi-google"></i> Continue with Google
        </button>
      </div>
    </div>
  {/if}
{/if}
